import { render, staticRenderFns } from "./MatrizResposta.vue?vue&type=template&id=857b4df6&"
import script from "./MatrizResposta.vue?vue&type=script&lang=js&"
export * from "./MatrizResposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports